import React, { useState, useRef } from 'react';
import {
  getVehicleRequestReport,
  getPurchaseOrderReport,
  getRunningVehicleReport,
  getServiceRemainderReport,
  getBreakdownReport,
} from '../../services/vm/apiController';
import { Table, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import FactoryDropdown from './FactoryDropdown';

const Report = () => {
  const [value, setValue] = useState({ reportType: '' });
  const clickToDownload = useRef(null);
  const formFields = { startDate: '', endDate: '', vehicleName: '', status: '', initiatedBy: '' };
  const PoFormFields = { startDate: '', endDate: '', purchaseNumber: '', vehicleName: '', initiatedBy: '' };
  const runningVehicleFormFields = { startDate: '', endDate: '', vehicleModelName: '', registrationNumber: '' };
  const serviceRemainderFormFields = {
    startDate: '',
    endDate: '',
    vehicleName: '',
    servicedStartDate: '',
    servicedEndDate: '',
    serviceStatus: '',
  };
  const breakdownFormFields = {
    startDate: '',
    endDate: '',
    vehicleName: '',
    servicedStartDate: '',
    servicedEndDate: '',
    breakdownStatus: '',
  };
  const [vehicleRequestForm, setVehicleRequestForm] = useState(formFields);
  const [POForm, setPOForm] = useState(PoFormFields);
  const [runningVehicleForm, setRunningVehicleForm] = useState(runningVehicleFormFields);
  const [serviceRemainderForm, setServiceRemainderForm] = useState(serviceRemainderFormFields);
  const [breakdownForm, setBreakdownForm] = useState(breakdownFormFields);
  const [vehicleReq, setVehicleReq] = useState('');
  const [purchaseOrder, setPurchaseOrder] = useState('');
  const [runningVehicle, setRunningVehicle] = useState('');
  const [serviceRemainder, setServiceRemainder] = useState('');
  const [breakdown, setBreakdown] = useState('');

  const handleSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setValue({ [name]: value });
    setVehicleReq('');
    setPurchaseOrder('');
    setRunningVehicle('');
    setServiceRemainder('');
    setBreakdown('');
  };

  const handleVehicleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setVehicleRequestForm({ ...vehicleRequestForm, [name]: value });
  };

  const handlePOChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPOForm({ ...POForm, [name]: value });
  };

  const handleRunningVehiclChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setRunningVehicleForm({ ...runningVehicleForm, [name]: value });
  };

  const handleServiceRemainderChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceRemainderForm({ ...serviceRemainderForm, [name]: value });
  };

  const handleBreakdownChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleBreakdownSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleServiceRemainderSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceRemainderForm({ ...serviceRemainderForm, [name]: value });
  };

  const handleVehicleSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setVehicleRequestForm({ ...vehicleRequestForm, [name]: value });
  };

  const handleSubmit = async (e, conditionType) => {
    e.preventDefault();
    if (value.reportType === 'vehicle')
      try {
        const data = await getVehicleRequestReport(
          vehicleRequestForm.startDate,
          vehicleRequestForm.endDate,
          vehicleRequestForm.vehicleName,
          vehicleRequestForm.status,
          vehicleRequestForm.initiatedBy,
          conditionType
        );
        setVehicleReq(data.data);
        if (data.data.filePath) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data.filePath;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'PO')
      try {
        const data = await getPurchaseOrderReport(
          POForm.startDate,
          POForm.endDate,
          POForm.vehicleName,
          POForm.purchaseNumber,
          POForm.initiatedBy,
          conditionType
        );
        setPurchaseOrder(data.data);
        if (data.data.filePath) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data.filePath;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'RV')
      try {
        const data = await getRunningVehicleReport(
          runningVehicleForm.startDate,
          runningVehicleForm.endDate,
          runningVehicleForm.vehicleModelName,
          runningVehicleForm.registrationNumber,
          conditionType
        );
        setRunningVehicle(data.data);
        if (data.data.filePath) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data.filePath;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'service')
      try {
        const data = await getServiceRemainderReport(
          serviceRemainderForm.startDate,
          serviceRemainderForm.endDate,
          serviceRemainderForm.vehicleName,
          serviceRemainderForm.servicedStartDate,
          serviceRemainderForm.servicedEndDate,
          serviceRemainderForm.serviceStatus,
          conditionType
        );
        setServiceRemainder(data.data);
        if (data.data.filePath) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data.filePath;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'breakdown')
      try {
        const data = await getBreakdownReport(
          breakdownForm.startDate,
          breakdownForm.endDate,
          breakdownForm.vehicleName,
          breakdownForm.servicedStartDate,
          breakdownForm.servicedEndDate,
          breakdownForm.breakdownStatus,
          conditionType
        );
        setBreakdown(data.data);
        if (data.data.filePath) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=` + data.data.filePath;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/vehicle-requests">Reports</Link>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown />
            <div className="form-group col-md-4 col-lg-4">
              <label htmlFor="exampleInputEmail1">Report For</label>
              <Form.Select
                value={value.reportType}
                onChange={handleSelect}
                name="reportType"
                aria-label="Select from which module you need to fetch report"
                required
              >
                <option>Select</option>
                <option value="vehicle">Vehicle Request</option>
                <option value="PO">Purchase Order</option>
                <option value="RV">Running Vehicle</option>
                <option value="service">Service Remainders</option>
                <option value="breakdown">Breakdown</option>
              </Form.Select>
            </div>
            {value.reportType === 'vehicle' ? (
              <>
                <div className="col-12 blockLine my-3">
                  <p className="my-0">
                    <strong>Filter criteria</strong>
                  </p>
                  <hr className="my-0" />
                </div>
                <Form className="mt-4">
                  <Row>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                        <Form.Control
                          onChange={handleVehicleChange}
                          value={vehicleRequestForm.startDate}
                          className="input"
                          name="startDate"
                          type="date"
                          placeholder="Start Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                        <Form.Control
                          onChange={handleVehicleChange}
                          value={vehicleRequestForm.endDate}
                          className="input"
                          name="endDate"
                          type="date"
                          placeholder="End Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                        <Form.Control
                          onChange={handleVehicleChange}
                          value={vehicleRequestForm.vehicleName}
                          className="input"
                          name="vehicleName"
                          type="text"
                          placeholder="Vehicle Date"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingSelect" label="Status">
                        <Form.Select
                          onChange={handleVehicleSelect}
                          value={vehicleRequestForm.status}
                          name="status"
                          aria-label="Floating label select example"
                        >
                          <option>Select Status</option>
                          <option value="VEHICLE REQUESTED">Vehicle Requested</option>
                          <option value="PO REQUESTED">PO Requested</option>
                          <option value="RUNNING VEHICLE">Running Vehicle</option>
                          <option value="SCRAP-RESELL">Scrap/Resell</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Initiated By" className="mb-3">
                        <Form.Control
                          onChange={handleVehicleChange}
                          value={vehicleRequestForm.initiatedBy}
                          className="input"
                          name="initiatedBy"
                          type="text"
                          placeholder="Initiated By"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : (
              ''
            )}
            {value.reportType === 'PO' ? (
              <>
                <div className="col-12 blockLine my-3">
                  <p className="my-0">
                    <strong>Filter criteria</strong>
                  </p>
                  <hr className="my-0" />
                </div>
                <Form className="mt-4">
                  <Row>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                        <Form.Control
                          onChange={handlePOChange}
                          value={POForm.startDate}
                          className="input"
                          name="startDate"
                          type="date"
                          placeholder="Start Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                        <Form.Control
                          onChange={handlePOChange}
                          value={POForm.endDate}
                          className="input"
                          name="endDate"
                          type="date"
                          placeholder="End Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Purchase Number" className="mb-3">
                        <Form.Control
                          onChange={handlePOChange}
                          value={POForm.purchaseNumber}
                          className="input"
                          name="purchaseNumber"
                          type="text"
                          placeholder="Purchase Number"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                        <Form.Control
                          onChange={handlePOChange}
                          value={POForm.vehicleName}
                          className="input"
                          name="vehicleName"
                          type="text"
                          placeholder="Vehicle Name"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                        <Form.Control
                          onChange={handlePOChange}
                          value={POForm.initiatedBy}
                          className="input"
                          name="initiatedBy"
                          type="text"
                          placeholder="Approved By"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : (
              ''
            )}
            {value.reportType === 'RV' ? (
              <>
                <div className="col-12 blockLine my-3">
                  <p className="my-0">
                    <strong>Filter criteria</strong>
                  </p>
                  <hr className="my-0" />
                </div>
                <Form className="mt-4">
                  <Row>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                        <Form.Control
                          onChange={handleRunningVehiclChange}
                          value={runningVehicleForm.startDate}
                          className="input"
                          name="startDate"
                          type="date"
                          placeholder="Start Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                        <Form.Control
                          onChange={handleRunningVehiclChange}
                          value={runningVehicleForm.endDate}
                          className="input"
                          name="endDate"
                          type="date"
                          placeholder="End Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Vehicle Model Name" className="mb-3">
                        <Form.Control
                          onChange={handleRunningVehiclChange}
                          value={runningVehicleForm.vehicleModelName}
                          className="input"
                          name="vehicleModelName"
                          type="text"
                          placeholder="Vehicle Model Name"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Registration Number" className="mb-3">
                        <Form.Control
                          onChange={handleRunningVehiclChange}
                          value={runningVehicleForm.registrationNumber}
                          className="input"
                          name="registrationNumber"
                          type="text"
                          placeholder="Registration Number"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : (
              ''
            )}
            {value.reportType === 'service' ? (
              <>
                <div className="col-12 blockLine my-3">
                  <p className="my-0">
                    <strong>Filter criteria</strong>
                  </p>
                  <hr className="my-0" />
                </div>
                <Form className="mt-4">
                  <Row>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                        <Form.Control
                          onChange={handleServiceRemainderChange}
                          value={serviceRemainderForm.startDate}
                          className="input"
                          name="startDate"
                          type="date"
                          placeholder="Start Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                        <Form.Control
                          onChange={handleServiceRemainderChange}
                          value={serviceRemainderForm.endDate}
                          className="input"
                          name="endDate"
                          type="date"
                          placeholder="End Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                        <Form.Control
                          onChange={handleServiceRemainderChange}
                          value={serviceRemainderForm.vehicleName}
                          className="input"
                          name="vehicleName"
                          type="text"
                          placeholder="Vehicle Name"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Serviced Start Date" className="mb-3">
                        <Form.Control
                          onChange={handleServiceRemainderChange}
                          value={serviceRemainderForm.servicedStartDate}
                          className="input"
                          name="servicedStartDate"
                          type="date"
                          placeholder="Serviced Start Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Serviced End Date" className="mb-3">
                        <Form.Control
                          onChange={handleServiceRemainderChange}
                          value={serviceRemainderForm.servicedEndDate}
                          className="input"
                          name="servicedEndDate"
                          type="date"
                          placeholder="Serviced End Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingSelect" label="Service Status">
                        <Form.Select
                          onChange={handleServiceRemainderSelect}
                          value={serviceRemainderForm.serviceStatus}
                          name="serviceStatus"
                          aria-label="Floating label select example"
                        >
                          <option>Select Service Status</option>
                          <option value="pending">Pending</option>
                          <option value="completed">Completed</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : (
              ''
            )}
            {value.reportType === 'breakdown' ? (
              <>
                <div className="col-12 blockLine my-3">
                  <p className="my-0">
                    <strong>Filter criteria</strong>
                  </p>
                  <hr className="my-0" />
                </div>
                <Form className="mt-4">
                  <Row>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                        <Form.Control
                          onChange={handleBreakdownChange}
                          value={breakdownForm.startDate}
                          className="input"
                          name="startDate"
                          type="date"
                          placeholder="Start Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                        <Form.Control
                          onChange={handleBreakdownChange}
                          value={breakdownForm.endDate}
                          className="input"
                          name="endDate"
                          type="date"
                          placeholder="End Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                        <Form.Control
                          onChange={handleBreakdownChange}
                          value={breakdownForm.vehicleName}
                          className="input"
                          name="vehicleName"
                          type="text"
                          placeholder="Vehicle Name"
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Serviced Start Date" className="mb-3">
                        <Form.Control
                          onChange={handleBreakdownChange}
                          value={breakdownForm.servicedStartDate}
                          className="input"
                          name="servicedStartDate"
                          type="date"
                          placeholder="Serviced Start Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Serviced End Date" className="mb-3">
                        <Form.Control
                          onChange={handleBreakdownChange}
                          value={breakdownForm.servicedEndDate}
                          className="input"
                          name="servicedEndDate"
                          type="date"
                          placeholder="Serviced End Date"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingSelect" label="Breakdown Status">
                        <Form.Select
                          onChange={handleBreakdownSelect}
                          value={breakdownForm.breakdownStatus}
                          name="breakdownStatus"
                          aria-label="Floating label select example"
                        >
                          <option>Select Breakdown Status</option>
                          <option value="pending">Pending</option>
                          <option value="repaired">Repaired</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : (
              ''
            )}
          </div>
        </div>
        <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
          HiddenClick
        </a>
        <div className="card-footer">
          <div className="btn-wrapper">
            <button
              onClick={() => {
                setVehicleRequestForm(formFields);
                setPOForm(PoFormFields);
                setRunningVehicleForm(runningVehicleFormFields);
                setServiceRemainderForm(serviceRemainderFormFields);
                setBreakdownForm(breakdownFormFields);
              }}
              className="btn app-btn-default"
            >
              Cancel
            </button>
            <button onClick={(e) => handleSubmit(e, 'viewOnly')} className="btn app-btn-primary">
              Fetch Report
            </button>
          </div>
        </div>
      </div>
      {vehicleReq?.count !== 0 && Object.keys(vehicleReq).length !== 0 ? (
        <div className="card">
          <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              All Vehicle Requests
            </h4>
            <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          </div>
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Vehicle</th>
                      <th>Requested By / Initiated By</th>
                      <th>Status</th>
                      <th>Requested Date</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicleReq?.rows?.map((request) => {
                      return (
                        <tr key={request?.id}>
                          <td>{request?.id}</td>
                          <td>{request?.model}</td>
                          <td>
                            {request?.requestedBy} / {request?.initiatedBy}
                          </td>
                          <td>{request?.status}</td>
                          <td>{formatDate(request?.requestedDate)}</td>
                          <td>{request?.reason}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      {purchaseOrder?.count !== 0 && Object.keys(purchaseOrder).length !== 0 ? (
        <div className="card">
          <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              All Purchase Order
            </h4>
            <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          </div>
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>PO Number</th>
                      <th>Name</th>
                      <th>Approved By</th>
                      <th>Approved Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseOrder?.rows?.map((request) => {
                      return (
                        <tr key={request?.id}>
                          <td>{request?.id}</td>
                          <td>{request?.purchaseNumber}</td>
                          <td>{request?.vehicleName}</td>
                          <td>{request?.approvedBy}</td>
                          <td>{formatDate(request?.approvedDate)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      {runningVehicle?.count !== 0 && Object.keys(runningVehicle).length !== 0 ? (
        <div className="card">
          <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              All Running Vehicle
            </h4>
            <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          </div>
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Registration Number</th>
                      <th>Additional Charges</th>
                      <th>On Road Date</th>
                      <th>Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    {runningVehicle?.rows?.map((request) => {
                      return (
                        <tr key={request?.id}>
                          <td>{request?.id}</td>
                          <td>{request?.registrationNumber}</td>
                          <td>{request?.charges}</td>
                          <td>{formatDate(request?.onRoadDate)}</td>
                          <td>{request?.location}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      {serviceRemainder?.count !== 0 && Object.keys(serviceRemainder).length !== 0 ? (
        <div className="card">
          <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              All Service Remainder
            </h4>
            <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          </div>
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name / Description</th>
                      <th>Vehicle Name</th>
                      <th>Vehicle Number</th>
                      <th>Status / Type</th>
                      <th>Due Date / Serviced Date</th>
                      <th>Showroom Name / Supervised By</th>
                      <th>Labour Cost / Material Cost / Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {serviceRemainder?.rows?.map((request) => {
                      return (
                        <tr key={request?.id}>
                          <td>{request?.id}</td>
                          <td>
                            {request?.serviceName} / {request?.description}
                          </td>
                          <td>{request?.runningVehicleName}</td>
                          <td>{request?.runningVehicleNumber}</td>
                          <td>
                            {request?.serviceStatus} / {request?.serviceType}
                          </td>
                          <td>
                            {formatDate(request?.dueDate)} / {formatDate(request?.servicedDate)}
                          </td>
                          <td>
                            {request?.showroomName} / {request?.supervisedBy}
                          </td>
                          <td>
                            {request?.labourCost} / {request?.mCost} / {request?.serviceComments}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      {breakdown?.count !== 0 && Object.keys(breakdown).length !== 0 ? (
        <div className="card">
          <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              All Breakdown
            </h4>
            <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
              Download Report
            </button>
          </div>
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Reason / Status / Supervised By</th>
                      <th>Vehicle Name</th>
                      <th>Break Date / Serviced Date</th>
                      <th>Reference Name</th>
                      <th>Labour Cost / Material Cost / Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {breakdown?.rows?.map((request) => {
                      return (
                        <tr key={request?.id}>
                          <td>{request?.id}</td>
                          <td>
                            {request?.reason} / {request?.status} / {request?.supervisedBy}
                          </td>
                          <td>{request?.runningVehicleName}</td>
                          <td>
                            {formatDate(request?.breakDate)} / {formatDate(request?.servicedDate)}
                          </td>
                          <td>{request?.referenceName}</td>
                          <td>
                            {request?.labourCost} / {request?.mCost} / {request?.serviceComments}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default Report;
